import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { StorageService } from 'src/app/generales/services/storage.service';
import { DataProduct } from 'src/app/generales/login/pages/perfil/interfaces-perfil/interfacesPerfil';

@Component({
  selector: 'app-slider-products',
  templateUrl: './slider-products.component.html',
  styleUrls: ['./slider-products.component.scss'],
})
export class SliderProductsComponent implements OnInit {
  @ViewChild(IonSlides) ionSlide: IonSlides;
  @Input() mostrarSeccion: boolean = true;
  @Input() texto: string = '';
  @Input() mostrarData;
  @Input() itemMedia:DataProduct[];
  @Input() padding:boolean = true;

  constructor() {}

  ngOnInit() {}

  slideOpts = {
    spaceBetween: 8,
    breakpoints: {
      319: {
        slidesPerView: 1.5,
      },
      419: {
        slidesPerView: 1.8,
      },
      540: {
        slidesPerView: 2.5,
      },
      620: {
        slidesPerView: 3.5,
      },
      830: {
        slidesPerView: 3.2,
      },
      1030: {
        slidesPerView: 4.2,
      },
      1270: {
        slidesPerView: 5,
      },
    },
  };

  slideTo(direction: string) {
    direction == 'next' ? this.ionSlide.slideNext() : this.ionSlide.slidePrev();
  }
}
